import { inject, Injectable } from '@angular/core';
import { showConsoleSecurityWarning } from './console-security-warning';
import { DevtoolsDetectionService } from './devtools-detection.service';
import { RUNTIME_PROTECTION_CONFIG } from './security.constants';
import { RuntimeProtectionConfig } from './security.types';

@Injectable({
  providedIn: 'root'
})
export class RuntimeProtectionService {

  private readonly _devtoolsDetectionService = inject(DevtoolsDetectionService);

  private _initialized = false;

  initialize(config: RuntimeProtectionConfig = RUNTIME_PROTECTION_CONFIG): void {
    if (this._initialized) return;

    showConsoleSecurityWarning(config.consoleWarning);
    this._devtoolsDetectionService.start(config.devtoolsDetection);

    this._initialized = true;
  }

}
